// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77efd235","455":"6680bb48","977":"6067cefc"}[chunkId] + ".chunk.js";
};